/* Progressive enhancement. Every category, sort and pagination link also works without JS. */
(() => {
  let controller;
  // Remontée douce et posée (~1,1 s, accélération puis ralentissement progressifs).
  function smoothToTop(duration) {
    const start = window.scrollY;
    if (start <= 0) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, 0); return; }
    const html = document.documentElement;
    const previous = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    // Pas d'« ancrage » du navigateur pendant que la grille se recharge : il freinerait la remontée.
    html.style.overflowAnchor = 'none';
    document.body.style.overflowAnchor = 'none';
    const restore = () => { html.style.scrollBehavior = previous; html.style.overflowAnchor = ''; document.body.style.overflowAnchor = ''; };
    const t0 = performance.now();
    const ease = t => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
    let cancelled = false;
    const cancel = () => { cancelled = true; };
    ['wheel', 'touchstart', 'keydown'].forEach(type => addEventListener(type, cancel, { once: true, passive: true }));
    const step = now => {
      if (cancelled) { restore(); return; }
      const p = Math.min(1, (now - t0) / duration);
      window.scrollTo(0, Math.round(start * (1 - ease(p))));
      if (p < 1) requestAnimationFrame(step);
      else restore();
    };
    requestAnimationFrame(step);
  }
  async function loadCatalog(url, { push = true, focus = false } = {}) {
    const current = document.querySelector('[data-catalog-section]');
    if (!current) { window.location.assign(url); return; }
    controller?.abort();
    controller = new AbortController();
    const requestController = controller;
    const target = new URL(url, window.location.origin);
    if (target.origin !== window.location.origin) return;
    const request = new URL(target);
    request.searchParams.set('section_id', current.dataset.catalogSection);
    current.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(request, { signal: requestController.signal });
      if (!response.ok) throw new Error('catalog');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-catalog-section]');
      if (!next) throw new Error('catalog');
      current.replaceWith(next);
      if (push) history.pushState({ catalog: true }, '', target);
      if (focus) {
        const count = next.querySelector('.catalog-count');
        count?.setAttribute('tabindex', '-1');
        count?.focus({ preventScroll: true });
      }
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(target.href);
    } finally {
      if (controller === requestController) document.querySelector('[data-catalog-section]')?.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-sort-control][open], [data-filter-control][open]').forEach(control => { if(!control.contains(event.target)) control.open = false; });
    const link = event.target.closest('[data-catalog-link], [data-catalog-pagination] a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (new URL(link.href).origin !== location.origin) return;
    event.preventDefault();
    // NUOMA 3.4 — Page suivante / précédente : retour en douceur en haut de la page.
    if (link.closest('[data-catalog-pagination]')) {
      smoothToTop(1100);
    }
    loadCatalog(link.href, { focus: true });
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-catalog-filter]')) {
      event.preventDefault(); const url = new URL(location.href); url.search = new URLSearchParams(new FormData(event.target)).toString(); loadCatalog(url.href, {focus: true}); return;
    }
    if (!event.target.matches('[data-catalog-sort]')) return;
    event.preventDefault();
    // Sur /collections/all, le tri s'applique à la collection du catalogue (action du formulaire).
    const url = new URL(event.target.getAttribute('action') ? event.target.action : location.href);
    url.searchParams.delete('page');
    url.searchParams.set('sort_by', new FormData(event.target).get('sort_by'));
    loadCatalog(url.href, { focus: true });
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-catalog-sort] input[type=radio]')) event.target.form.requestSubmit();
  });
  document.addEventListener('keydown', event => {
    if(event.key === 'Escape') document.querySelectorAll('[data-sort-control][open], [data-filter-control][open]').forEach(control => {control.open=false;control.querySelector('summary').focus();});
  });
  window.addEventListener('popstate', () => {
    if (document.querySelector('[data-catalog-section]')) loadCatalog(location.href, { push: false });
  });
})();
